import React, { useState, useEffect } from 'react';
import { getSpeseTecniche, saveSpeseTecniche } from '../services/budgetSpeseTecnicheService';

const CODICI_RIFERIMENTO = {
    'Permesso di Costruire': 'B001',
    'Progetto Architettonico': 'B002',
    'Progetto Strutturale': 'B003',
    'Progetto Impianti Elettrici': 'B004',
    'Progetto Impianti Meccanici / Idrico Sanitario': 'B005',
    'Coordinatore Sicurezza CSE + CSP': 'B006',
    'Direzione Lavori Architettonico': 'B007',
    'Direzione Lavori Strutturale': 'B008',
    'Direzione Lavori Impianti Elettrici': 'B009',
    'Direzione Lavori Impianti Meccanici': 'B010',
    'Geologo': 'B011',
    'Acustico': 'B012',
    'Legge 10 + APE': 'B013',
    'Spese Professionali (INCLUSO VVF)': 'B014',
    'prove e Analisi': 'B015',
    'Perizie': 'B016',
};

const BudgetSpeseTecnicheTable = ({ cantiereId, onTotaleCalcolato }) => {
    const [dati, setDati] = useState([]);
    const [loading, setLoading] = useState(true);
    const [formData, setFormData] = useState({});
    const [formVisible, setFormVisible] = useState(false);
    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };
    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [`${name}_usa_slp`]: checked,
        }));
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const payload = [];

            Object.keys(formData).forEach((key) => {
                if (
                    key.endsWith('_usa_slp') ||
                    key.endsWith('_quantita_custom') ||
                    key === 'cantiere_id'
                ) {
                    return;
                }

                const voce = key;
                const prezzo_unitario = parseFloat(formData[voce]) || 0;
                const usa_slp = formData[`${voce}_usa_slp`] !== false; // default true

                const voceData = {
                    voce,
                    prezzo_unitario,
                    usa_slp,
                    cantiere_id: cantiereId,
                    codice_riferimento: CODICI_RIFERIMENTO[voce] || null,
                };

                if (!usa_slp) {
                    voceData.quantita_custom = parseFloat(formData[`${voce}_quantita_custom`] || 0);
                }

                payload.push(voceData);

            });

            const res = await saveSpeseTecniche(cantiereId, payload);
            alert(res?.message || 'Dati salvati con successo!');
            const refreshed = await getSpeseTecniche(cantiereId);
            const sortedRefreshed = (refreshed.data || []).sort((a, b) =>
                (a.codice_riferimento || '').localeCompare(b.codice_riferimento || '')
            );
            setDati(sortedRefreshed);
            setFormData({});
            setFormVisible(false);
        } catch (error) {
            console.error('Errore durante il salvataggio:', error);
            alert('Errore durante il salvataggio dei dati.');
        }
    };

    useEffect(() => {
        const fetchDati = async () => {
            try {
                const res = await getSpeseTecniche(cantiereId);
                if (res.success && Array.isArray(res.data)) {
                    const sortedData = (res.data || []).sort((a, b) =>
                        (a.codice_riferimento || '').localeCompare(b.codice_riferimento || '')
                    );
                    setDati(sortedData);
                    // Popola il form con i dati esistenti
                    const initialForm = {};
                    sortedData.forEach((item) => {
                        initialForm[item.voce] = item.prezzo_unitario;
                        initialForm[`${item.voce}_usa_slp`] = item.usa_slp;
                        if (!item.usa_slp) {
                            initialForm[`${item.voce}_quantita_custom`] = item.quantita_custom || '';
                        }
                    });
                    setFormData(initialForm);
                } else {
                    setDati([]);
                }
            } catch (err) {
                console.error('Errore nel recupero spese tecniche:', err);
                setDati([]);
            } finally {
                setLoading(false);
            }
        };

        fetchDati();
    }, [cantiereId]);

    const slpUnico = dati.find((v) => v.superficie_slp)?.superficie_slp || 0;

    useEffect(() => {
        if (!loading && dati.length > 0) {
            const totalePrevistoComplessivo = dati
                .filter((v) => v.voce !== 'Spese Tecniche')
                .reduce((acc, voce) => {
                    const quantita = voce.usa_slp ? voce.superficie_slp : voce.quantita_custom || 0;
                    return acc + (voce.prezzo_unitario != null ? voce.prezzo_unitario * quantita : 0);
                }, 0);


            if (onTotaleCalcolato) {
                onTotaleCalcolato(totalePrevistoComplessivo);
            }
        }
    }, [loading, dati, onTotaleCalcolato]);

    if (loading) return <div>Caricamento...</div>;

    // Se non ci sono dati o formVisible è true, mostra form
    if (dati.length === 0 || formVisible) {
        return (
            <form onSubmit={handleSubmit} className="p-4 border rounded bg-light mt-4">
                <div className="row">
                    {[
                        'Permesso di Costruire',
                        'Progetto Architettonico',
                        'Progetto Strutturale',
                        'Progetto Impianti Elettrici',
                        'Progetto Impianti Meccanici / Idrico Sanitario',
                        'Coordinatore Sicurezza CSE + CSP',
                        'Direzione Lavori Architettonico',
                        'Direzione Lavori Strutturale',
                        'Direzione Lavori Impianti Elettrici',
                        'Direzione Lavori Impianti Meccanici',
                        'Geologo',
                        'Acustico',
                        'Legge 10 + APE',
                        'Spese Professionali (INCLUSO VVF)',
                        'prove e Analisi',
                        'Perizie'
                    ].map((voce) => (
                        <div className="col-md-6 mb-4" key={voce}>
                            <label className="form-label fw-bold">{voce}</label>
                            <div className="d-flex align-items-center gap-3">
                                <input
                                    type="number"
                                    name={voce}
                                    value={formData[voce] || ''}
                                    onChange={handleChange}
                                    className="form-control"
                                    placeholder="€"
                                />
                                <div className="form-check m-0">
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        name={voce}
                                        id={`check-${voce}`}
                                        checked={formData[`${voce}_usa_slp`] !== undefined ? formData[`${voce}_usa_slp`] : true}
                                        onChange={handleCheckboxChange}
                                    />
                                    <label className="form-check-label" htmlFor={`check-${voce}`}>
                                        SLP
                                    </label>
                                </div>
                            </div>
                            {formData[`${voce}_usa_slp`] === false && (
                                <div className="mt-2">
                                    <input
                                        type="number"
                                        name={`${voce}_quantita_custom`}
                                        value={formData[`${voce}_quantita_custom`] || ''}
                                        onChange={handleChange}
                                        className="form-control"
                                        placeholder="Quantità personalizzata"
                                    />
                                </div>
                            )}
                        </div>
                    ))}
                </div>
                <div className="text-end mt-3">
                    <button type="submit" className={dati.length === 0 ? "btn btn-primary" : "btn btn-success"}>
                        {dati.length === 0 ? "Salva" : "Salva Modifiche"}
                    </button>
                </div>
            </form>
        );
    }


    // Se ci sono dati e formVisible è false, mostra tabella
    const totalePrevistoComplessivo = dati.filter((v) => v.voce !== 'Spese Tecniche').reduce((acc, voce) => {
        const quantita = voce.usa_slp ? voce.superficie_slp : voce.quantita_custom || 0;
        return acc + (voce.prezzo_unitario != null ? voce.prezzo_unitario * quantita : 0);
    }, 0); // <-- questa variabile viene ora calcolata solo per la visualizzazione, non più inviata al padre

    const prezzoMedio = slpUnico > 0 ? totalePrevistoComplessivo / slpUnico : 0;

    return (
        <div className="table-responsive mt-4">
            <table className="table table-bordered table-striped">
                <thead className="table-dark">
                    <tr>
                        <th>COSTI SPESE TECNICHE</th>
                        <th>%</th>
                        <th>PREZZO (€)</th>
                        <th>QUANTITÀ</th>
                        <th>TOTALE PREVISTO</th>
                        <th>CODICE DI RIFERIMENTO</th>
                    </tr>
                </thead>
                <tbody>
                    <tr className="table-info fw-bold">
                        <td>Spese Tecniche</td>
                        <td>
                            {totalePrevistoComplessivo > 0
                                ? `${((totalePrevistoComplessivo / totalePrevistoComplessivo) * 100).toFixed(2)}%`
                                : '—'}
                        </td>
                        <td>
                            {new Intl.NumberFormat('it-IT', {
                                style: 'currency',
                                currency: 'EUR',
                            }).format(prezzoMedio)}
                        </td>
                        <td>{new Intl.NumberFormat('it-IT').format(slpUnico)}</td>
                        <td>
                            {new Intl.NumberFormat('it-IT', {
                                style: 'currency',
                                currency: 'EUR',
                            }).format(totalePrevistoComplessivo)}
                        </td>
                        <td>B000</td>
                    </tr>
                    {dati.map((voce, idx) => {
                        const usaSLP = voce.usa_slp;
                        const quantitaVal = usaSLP ? voce.superficie_slp : voce.quantita_custom || 0;
                        const totaleCalcolato = voce.prezzo_unitario != null ? voce.prezzo_unitario * quantitaVal : null;
                        const quantita = usaSLP
                            ? voce.superficie_slp
                                ? `${new Intl.NumberFormat('it-IT').format(voce.superficie_slp)}`
                                : '-'
                            : voce.quantita_custom != null
                                ? new Intl.NumberFormat('it-IT').format(voce.quantita_custom)
                                : '0';
                        return (
                            <tr key={idx}>
                                <td>{voce.nome_voce || voce.voce || '—'}</td>
                                <td>
                                    {voce.prezzo_unitario != null && totalePrevistoComplessivo > 0
                                        ? `${((voce.prezzo_unitario * (voce.usa_slp ? voce.superficie_slp : voce.quantita_custom || 0)) / totalePrevistoComplessivo * 100).toFixed(2)}%`
                                        : '—'}
                                </td>
                                <td>
                                    {voce.prezzo_unitario != null
                                        ? new Intl.NumberFormat('it-IT', {
                                              style: 'currency',
                                              currency: 'EUR',
                                          }).format(voce.prezzo_unitario)
                                        : '—'}
                                </td>
                                <td>{quantita}</td>
                                <td>
                                    {totaleCalcolato != null
                                        ? new Intl.NumberFormat('it-IT', {
                                              style: 'currency',
                                              currency: 'EUR',
                                          }).format(totaleCalcolato)
                                        : '—'}
                                </td>
                                <td>{voce.codice_riferimento || '—'}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            <div className="text-end mt-3">
                <button
                    className="btn btn-warning"
                    onClick={() => setFormVisible(true)}
                >
                    ✏️ Modifica Dati
                </button>
            </div>
        </div>
    );
};

export default BudgetSpeseTecnicheTable;